export const isQaOrSbx = (): boolean => {
  try {
    const metaEnv = (import.meta as any).env || {};
    const processEnv = (typeof process !== 'undefined' ? process.env : {}) || {};

    const appEnv = (
      (metaEnv.VITE_APP_ENV || processEnv.VITE_APP_ENV || '') as string
    ).toLowerCase();
    const mode = ((metaEnv.MODE || processEnv.NODE_ENV || '') as string).toLowerCase();
    const apiUrl = (
      (metaEnv.VITE_API_URL || processEnv.VITE_API_URL || '') as string
    ).toLowerCase();

    return (
      appEnv === 'qa' ||
      appEnv === 'sbx' ||
      mode === 'qa' ||
      mode === 'sbx' ||
      apiUrl.includes('qa-albo') ||
      apiUrl.includes('sbx-albo') ||
      apiUrl.includes('.qa.') ||
      apiUrl.includes('.sbx.')
    );
  } catch {
    return false;
  }
};
